




















import Vue from 'vue'
import { mapState } from 'vuex'

import config from '@/config'
import Message from '@/elements/Message.vue'

import { ChatPromiseClient } from 'schema/chat_grpc_web_pb'
import { ClientMessage, ServerMessage, GetMessagesRequest } from 'schema/chat_pb'

const client = new ChatPromiseClient(config.hostname, null, null)

export default Vue.extend({
  name: 'chat',
  components: {
    Message,
  },
  data: () => {
    return {
      message: '',
    }
  },
  mounted() {
    const username = this.$store.state.user.username

    if (username !== '') {
      this.getMessages(username)
    } else {
      this.setupWatch(username)
    }
  },
  methods: {
    setupWatch(username: string) {
      this.$store.watch(
        (state: any, getters: any) => getters['user/getUsername'],
        (newValue, oldValue) => {
          if (newValue !== '') {
            this.getMessages(newValue)
          }
        },
      )
    },
    getMessages(username: string) {
      if (username === '') {
        return
      }

      const req = new GetMessagesRequest()
      req.setUsername(username)
      const stream = client.getMessages(req, {})

      stream.on('data', (res: ServerMessage) => {
        this.$store.commit('chat/addMessage', res.toObject())
      })
      stream.on('error', (err: any) => {
        this.$store.commit('user/setUsername', '')
        alert(`Failed to get messages: ${err.message}`)
      })
    },
    sendMessage() {
      if (this.message === '') {
        return
      }
      const username = this.$store.state.user.username
      const req = new ClientMessage()
      req.setMessage(this.message)

      client.sendMessage(req, { username }).catch((err: any) => {
        alert(`Failed to send message: ${err.message}`)
      })

      this.message = ''
    },
  },
})
